import { render, staticRenderFns } from "./MoodArchives.vue?vue&type=template&id=94ae1980&scoped=true"
import script from "./MoodArchives.vue?vue&type=script&lang=js"
export * from "./MoodArchives.vue?vue&type=script&lang=js"
import style0 from "./MoodArchives.vue?vue&type=style&index=0&id=94ae1980&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ae1980",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94ae1980')) {
      api.createRecord('94ae1980', component.options)
    } else {
      api.reload('94ae1980', component.options)
    }
    module.hot.accept("./MoodArchives.vue?vue&type=template&id=94ae1980&scoped=true", function () {
      api.rerender('94ae1980', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/ArchivesViewPage/components/MoodArchives.vue"
export default component.exports